

// // src/components/Asignaciones/AsignarMateriaProfesor.jsx
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import io from "socket.io-client";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/AsignarMateriasProfesor.css";

// // const API = process.env.REACT_APP_API || "http://localhost:5001/api";
// const API = process.env.REACT_APP_API_BASE || "http://3.236.217.225:5001/api";
// const socket = io(API); // usar la URL del API dinámicamente

// function AsignarMateriaProfesor() {
//   const { user, token } = useAuth();

//   const [profesores, setProfesores] = useState([]);
//   const [materias, setMaterias] = useState([]);
//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);

//   const [profesorId, setProfesorId] = useState("");
//   const [materiaId, setMateriaId] = useState("");
//   const [gradoNombre, setGradoNombre] = useState("");
//   const [grupo, setGrupo] = useState("");

//   const [mensaje, setMensaje] = useState("");
//   const [mostrarAsignaciones, setMostrarAsignaciones] = useState(false);
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [cargandoAsignaciones, setCargandoAsignaciones] = useState(false);

//   const [editandoId, setEditandoId] = useState(null);
//   const [editData, setEditData] = useState({
//     profesor_id: "",
//     materia_id: "",
//     grado: "",
//     grupo: "",
//   });

//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "x-tenant-id": user?.tenant_id,
//     "x-sede-id": user?.sede_id,
//   };

//   const profesorSeleccionado = profesores.find((p) => p.id === Number(profesorId));
//   const profesorNombre = profesorSeleccionado
//     ? `${profesorSeleccionado.nombre} ${profesorSeleccionado.apellido}`
//     : "";

//   // --- Cargar profesores y materias ---
//   useEffect(() => {
//     if (!token || !user) return;
//     async function fetchInitialData() {
//       try {
//         const [profRes, matRes] = await Promise.all([
//           axios.get(`${API}/asignaciones/profesores`, { headers }),
//           axios.get(`${API}/asignaciones/materias`, { headers }),
//         ]);
//         setProfesores(profRes.data);
//         setMaterias(matRes.data);
//       } catch (error) {
//         console.error("Error cargando datos iniciales:", error);
//         setMensaje("❌ Error cargando datos iniciales");
//       }
//     }
//     fetchInitialData();
//   }, [token, user]);

//   // --- Cargar grados ---
//   useEffect(() => {
//     async function fetchGrados() {
//       try {
//         const res = await axios.get(`${API}/asignaciones/grados`, { headers });
//         setGrados(Array.isArray(res.data) ? res.data : []);
//       } catch (error) {
//         console.error("Error cargando grados:", error);
//         setGrados([]);
//       }
//     }
//     fetchGrados();
//   }, [token, user]);

//   // --- Cargar grupos según grado ---
// // src/components/Asignaciones/AsignarMateriaProfesor.jsx
// useEffect(() => {
//   async function fetchGrupos() {
//     try {
//       let url = gradoNombre
//         ? `${API}/asignaciones/grupos-matriculas/${encodeURIComponent(gradoNombre)}`
//         : `${API}/asignaciones/grupos-matriculas`; // todos los grupos si no hay grado seleccionado

//       const res = await axios.get(url, { headers });

//       // res.data = { '10': ['A','B'], '11': ['A','B','C'] }
//       if (gradoNombre) {
//         // si seleccionamos un grado, tomamos solo sus grupos
//         setGrupos(res.data[gradoNombre] || []);
//       } else {
//         // si no hay grado seleccionado, podemos aplanar todos los grupos
//         const todosGrupos = Object.values(res.data).flat();
//         setGrupos(todosGrupos);
//       }
//       setGrupo(""); // resetear select
//     } catch (error) {
//       console.error("Error cargando grupos desde matriculas:", error);
//       setGrupos([]);
//       setGrupo("");
//     }
//   }

//   fetchGrupos();
// }, [gradoNombre, token, user]);



//   // --- WebSocket para actualizar en tiempo real ---
//   useEffect(() => {
//     if (!user) return;
//     socket.on("nueva-asignacion", (data) => {
//       if (data.tenant_id === user.tenant_id && data.sede_id === user.sede_id)
//         setAsignaciones((prev) => [data, ...prev]);
//     });
//     socket.on("actualizar-asignacion", (data) => {
//       if (data.tenant_id === user.tenant_id && data.sede_id === user.sede_id)
//         setAsignaciones((prev) =>
//           prev.map((a) => (a.id === data.id ? data : a))
//         );
//     });
//     socket.on("eliminar-asignacion", (data) => {
//       if (data.tenant_id === user.tenant_id && data.sede_id === user.sede_id)
//         setAsignaciones((prev) => prev.filter((a) => a.id !== data.id));
//     });
//     return () => {
//       socket.off("nueva-asignacion");
//       socket.off("actualizar-asignacion");
//       socket.off("eliminar-asignacion");
//     };
//   }, [user]);

//   // --- Cargar asignaciones ---
//   async function fetchAsignaciones() {
//     setCargandoAsignaciones(true);
//     try {
//       const res = await axios.get(`${API}/asignaciones`, { headers });
//       setAsignaciones(res.data);
//     } catch (error) {
//       console.error("Error cargando asignaciones:", error);
//       setMensaje("❌ Error cargando asignaciones");
//     } finally {
//       setCargandoAsignaciones(false);
//     }
//   }
//   useEffect(() => {
//     if (mostrarAsignaciones) fetchAsignaciones();
//   }, [mostrarAsignaciones]);

//   // --- Crear asignación ---
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMensaje("");
//     if (!profesorId || !materiaId || !gradoNombre || !grupo) {
//       setMensaje("⚠️ Todos los campos son obligatorios");
//       return;
//     }
//     const payload = {
//       profesor_id: Number(profesorId),
//       materia_id: Number(materiaId),
//       grado: gradoNombre,
//       grupo,
//     };
//     try {
//       await axios.post(`${API}/asignaciones`, payload, { headers });
//       setMensaje("✅ Asignación realizada correctamente");
//       setProfesorId("");
//       setMateriaId("");
//       setGradoNombre("");
//       setGrupo("");
//       if (mostrarAsignaciones) fetchAsignaciones();
//     } catch (error) {
//       console.error("Error:", error);
//       setMensaje(error.response?.data?.message || "❌ Error al asignar");
//     }
//   };

//   // --- Edición ---
//   const iniciarEdicion = (a) => {
//     setEditandoId(a.id);
//     setEditData({
//       profesor_id: a.profesor_id,
//       materia_id: a.materia_id,
//       grado: a.grado,
//       grupo: a.grupo,
//     });
//   };
//   const cancelarEdicion = () => {
//     setEditandoId(null);
//     setEditData({ profesor_id: "", materia_id: "", grado: "", grupo: "" });
//   };
//   const guardarEdicion = async (id) => {
//     const { profesor_id, materia_id, grado, grupo } = editData;
//     if (!profesor_id || !materia_id || !grado || !grupo) {
//       setMensaje("⚠️ Todos los campos son obligatorios");
//       return;
//     }
//     const payload = { profesor_id: Number(profesor_id), materia_id: Number(materia_id), grado, grupo };
//     try {
//       await axios.put(`${API}/asignaciones/${id}`, payload, { headers });
//       setMensaje("✅ Actualizado correctamente");
//       cancelarEdicion();
//       if (mostrarAsignaciones) fetchAsignaciones();
//     } catch (error) {
//       setMensaje(error.response?.data?.message || "❌ Error al actualizar");
//     }
//   };

//   // --- Eliminar ---
//   const eliminarAsignacion = async (id) => {
//     if (!window.confirm("¿Eliminar esta asignación?")) return;
//     try {
//       await axios.delete(`${API}/asignaciones/${id}`, { headers });
//       setMensaje("✅ Asignación eliminada");
//       if (mostrarAsignaciones) fetchAsignaciones();
//     } catch (error) {
//       setMensaje(error.response?.data?.message || "❌ Error al eliminar");
//     }
//   };

//    const gruposUnicos = [...new Set(grupos)];

//   return (
//     <div className="asignar-container">
//       <h2>Asignar Materia a Profesor</h2>

//       {profesorNombre && (
//         <h3 className="profesor-titulo">
//           Profesor seleccionado: <strong>{profesorNombre}</strong>
//         </h3>
//       )}

//       <form className="asignar-form" onSubmit={handleSubmit}>
//         <div>
//           <label>Profesor:</label>
//           <select value={profesorId} onChange={(e) => setProfesorId(e.target.value)}>
//             <option value="">Seleccione un profesor</option>
//             {profesores.map((p) => (
//               <option key={p.id} value={p.id}>
//                 {p.nombre} {p.apellido} ({p.sede_nombre})
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label>Materia:</label>
//           <select value={materiaId} onChange={(e) => setMateriaId(e.target.value)}>
//             <option value="">Seleccione una materia</option>
//             {materias.map((m) => (
//               <option key={m.id} value={m.id}>
//                 {m.nombre}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label>Grado:</label>
//           <select value={gradoNombre} onChange={(e) => setGradoNombre(e.target.value)}>
//             <option value="">Seleccione un grado</option>
//             {grados.map((g, i) => (
//               <option key={i} value={g}>
//                 {g}
//               </option>
//             ))}
//           </select>
//         </div>

//    <div>
//       <label>Grupo:</label>
//       <select
//         value={grupo}
//         onChange={(e) => setGrupo(e.target.value)}
//         disabled={!gruposUnicos.length}
//       >
//         <option value="">Seleccione un grupo</option>
//         {gruposUnicos.map((gr) => (
//           <option key={gr} value={gr}>
//             {gr}
//           </option>
//         ))}
//       </select>
//     </div>

//         <button type="submit">Asignar</button>
//       </form>

//       <button className="toggle-asignaciones" onClick={() => setMostrarAsignaciones(!mostrarAsignaciones)}>
//         {mostrarAsignaciones ? "Ocultar Asignaciones" : "Ver Asignaciones"}
//       </button>

//       {mensaje && <p className="mensaje">{mensaje}</p>}

//       {mostrarAsignaciones && (
//         <div style={{ marginTop: 20, overflowX: "auto" }}>
//           <h3>Asignaciones Realizadas</h3>
//           {cargandoAsignaciones ? (
//             <p>Cargando...</p>
//           ) : asignaciones.length === 0 ? (
//             <p>No hay asignaciones.</p>
//           ) : (
//             <>
//               <p style={{ fontWeight: "600" }}>Total: {asignaciones.length}</p>
//               <table className="tabla-asignaciones">
//                 <thead>
//                   <tr>
//                     <th>ID</th>
//                     <th>Profesor</th>
//                     <th>Sede</th>
//                     <th>Materia</th>
//                     <th>Grado</th>
//                     <th>Grupo</th>
//                     <th>Acciones</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {asignaciones.map((a) => (
//                     <tr key={a.id}>
//                       <td>{a.id}</td>
//                       <td>{a.profesor_nombre || `${a.profesor?.nombre} ${a.profesor?.apellido}`}</td>
//                       <td>{a.sede_nombre}</td>
//                       <td>{a.materia_nombre || a.materia}</td>
//                       <td>{a.grado}</td>
//                       <td>{a.grupo}</td>
//                       <td>
//                         <button onClick={() => iniciarEdicion(a)}>Editar</button>
//                         <button onClick={() => eliminarAsignacion(a.id)}>Eliminar</button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// export default AsignarMateriaProfesor;


//

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "../../api/axiosAuth";
// import io from "socket.io-client";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/AsignarMateriasProfesor.css";

// // 1. CORREGIDO: Usamos la URL base sin puerto explícito para evitar bloqueos
// const SOCKET_URL = "http://3.236.217.225"; 

// function AsignarMateriaProfesor() {
//   const { user, token } = useAuth();

//   const [profesores, setProfesores] = useState([]);
//   const [materias, setMaterias] = useState([]);
//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);

//   const [profesorId, setProfesorId] = useState("");
//   const [materiaId, setMateriaId] = useState("");
//   const [gradoNombre, setGradoNombre] = useState("");
//   const [grupo, setGrupo] = useState("");

//   const [mensaje, setMensaje] = useState("");
//   const [mostrarAsignaciones, setMostrarAsignaciones] = useState(false);
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [cargandoAsignaciones, setCargandoAsignaciones] = useState(false);

//   // 2. CORREGIDO: Headers centralizados
//   const headers = useMemo(() => ({
//     Authorization: `Bearer ${token}`,
//     "x-tenant-id": user?.tenant_id,
//     "x-sede-id": user?.sede_id,
//   }), [token, user]);

//   const profesorSeleccionado = profesores.find((p) => p.id === Number(profesorId));
//   const profesorNombre = profesorSeleccionado
//     ? `${profesorSeleccionado.nombre} ${profesorSeleccionado.apellido}`
//     : "";

//   // --- Cargar datos iniciales ---
//   useEffect(() => {
//     if (!token || !user) return;
//     async function fetchInitialData() {
//       try {
//         const [profRes, matRes, gradosRes] = await Promise.all([
//           axios.get("/asignaciones/profesores", { headers }),
//           axios.get("/asignaciones/materias", { headers }),
//           axios.get("/asignaciones/grados", { headers })
//         ]);
//         setProfesores(profRes.data || []);
//         setMaterias(matRes.data || []);
//         setGrados(Array.isArray(gradosRes.data) ? gradosRes.data : []);
//       } catch (error) {
//         console.error("❌ Error cargando datos:", error);
//         setMensaje("❌ Error al sincronizar con el servidor");
//       }
//     }
//     fetchInitialData();
//   }, [token, user, headers]);

//   // --- Cargar grupos según grado seleccionado ---
//   useEffect(() => {
//     if (!token || !user) return;
//     async function fetchGrupos() {
//       try {
//         const url = gradoNombre
//           ? `/asignaciones/grupos-matriculas/${encodeURIComponent(gradoNombre)}`
//           : `/asignaciones/grupos-matriculas`;

//         const res = await axios.get(url, { headers });

//         if (gradoNombre) {
//           setGrupos(res.data[gradoNombre] || []);
//         } else {
//           const todosGrupos = Object.values(res.data).flat();
//           setGrupos([...new Set(todosGrupos)]);
//         }
//         setGrupo(""); 
//       } catch (error) {
//         console.error("Error cargando grupos:", error);
//         setGrupos([]);
//       }
//     }
//     fetchGrupos();
//   }, [gradoNombre, token, user, headers]);

//   // --- WebSocket para tiempo real ---
//   useEffect(() => {
//     if (!user) return;
//     const socket = io(SOCKET_URL);

//     socket.on("nueva-asignacion", (data) => {
//       if (data.tenant_id === user.tenant_id && data.sede_id === user.sede_id)
//         setAsignaciones((prev) => [data, ...prev]);
//     });

//     socket.on("eliminar-asignacion", (data) => {
//       if (data.tenant_id === user.tenant_id && data.sede_id === user.sede_id)
//         setAsignaciones((prev) => prev.filter((a) => a.id !== data.id));
//     });

//     return () => socket.disconnect();
//   }, [user]);

//   // --- CRUD Asignaciones ---
//   async function fetchAsignaciones() {
//     setCargandoAsignaciones(true);
//     try {
//       const res = await axios.get("/asignaciones", { headers });
//       setAsignaciones(res.data);
//     } catch (error) {
//       setMensaje("❌ Error al obtener asignaciones");
//     } finally {
//       setCargandoAsignaciones(false);
//     }
//   }

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!profesorId || !materiaId || !gradoNombre || !grupo) {
//       setMensaje("⚠️ Complete todos los campos");
//       return;
//     }

//     try {
//       await axios.post("/asignaciones", {
//         profesor_id: Number(profesorId),
//         materia_id: Number(materiaId),
//         grado: gradoNombre,
//         grupo,
//       }, { headers });

//       setMensaje("✅ Asignación creada con éxito");
//       setMateriaId("");
//       setGradoNombre("");
//       setGrupo("");
//       if (mostrarAsignaciones) fetchAsignaciones();
//     } catch (error) {
//       setMensaje(error.response?.data?.message || "❌ Error al asignar");
//     }
//   };

//   const eliminarAsignacion = async (id) => {
//     if (!window.confirm("¿Desea eliminar esta asignación académica?")) return;
//     try {
//       await axios.delete(`/asignaciones/${id}`, { headers });
//       setMensaje("🗑️ Asignación eliminada");
//       fetchAsignaciones();
//     } catch (error) {
//       setMensaje("❌ No se pudo eliminar");
//     }
//   };

//   return (
//     <div className="asignar-container">
//       <header className="asignar-header">
//         <h2>📂 Carga Académica</h2>
//         <p>Vincule docentes con materias y grupos</p>
//       </header>

//       {profesorNombre && (
//         <div className="profesor-alerta">
//           Docente: <strong>{profesorNombre}</strong>
//         </div>
//       )}

//       <form className="asignar-form" onSubmit={handleSubmit}>
//         <div className="form-grid">
//           <div className="input-field">
//             <label>Docente:</label>
//             <select value={profesorId} onChange={(e) => setProfesorId(e.target.value)}>
//               <option value="">Seleccione un profesor</option>
//               {profesores.map((p) => (
//                 <option key={p.id} value={p.id}>{p.nombre} {p.apellido}</option>
//               ))}
//             </select>
//           </div>

//           <div className="input-field">
//             <label>Materia:</label>
//             <select value={materiaId} onChange={(e) => setMateriaId(e.target.value)}>
//               <option value="">Seleccione una materia</option>
//               {materias.map((m) => (
//                 <option key={m.id} value={m.id}>{m.nombre}</option>
//               ))}
//             </select>
//           </div>

//           <div className="input-field">
//             <label>Grado:</label>
//             <select value={gradoNombre} onChange={(e) => setGradoNombre(e.target.value)}>
//               <option value="">Seleccione grado</option>
//               {grados.map((g, i) => <option key={i} value={g}>{g}</option>)}
//             </select>
//           </div>

//           <div className="input-field">
//             <label>Grupo:</label>
//             <select value={grupo} onChange={(e) => setGrupo(e.target.value)} disabled={!grupos.length}>
//               <option value="">Seleccione grupo</option>
//               {grupos.map((gr) => <option key={gr} value={gr}>{gr}</option>)}
//             </select>
//           </div>
//         </div>

//         <button type="submit" className="btn-asignar">Realizar Asignación</button>
//       </form>

//       <div className="acciones-footer">
//         <button className="btn-toggle" onClick={() => setMostrarAsignaciones(!mostrarAsignaciones)}>
//           {mostrarAsignaciones ? "Ocultar Listado" : "Ver Asignaciones Actuales"}
//         </button>
//         {mensaje && <span className="mensaje-status">{mensaje}</span>}
//       </div>

//       {mostrarAsignaciones && (
//         <div className="tabla-wrapper">
//           <h3>Asignaciones en {user?.sede_nombre}</h3>
//           {cargandoAsignaciones ? (
//             <p>⌛ Cargando registros...</p>
//           ) : (
//             <table className="tabla-asignaciones">
//               <thead>
//                 <tr>
//                   <th>Docente</th>
//                   <th>Materia</th>
//                   <th>Grado/Grupo</th>
//                   <th>Acciones</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {asignaciones.map((a) => (
//                   <tr key={a.id}>
//                     <td>{a.profesor_nombre || `${a.profesor?.nombre} ${a.profesor?.apellido}`}</td>
//                     <td>{a.materia_nombre || a.materia}</td>
//                     <td>{a.grado}° - {a.grupo}</td>
//                     <td>
//                       <button className="btn-delete" onClick={() => eliminarAsignacion(a.id)}>Eliminar</button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }

// export default AsignarMateriaProfesor;


///

import React, { useEffect, useState, useMemo, useCallback } from "react";
// 1. Importamos la instancia configurada y la URL del socket desde config
import axios from "../../api/axiosAuth"; 
import { SOCKET_URL } from "../config"; 
import io from "socket.io-client";
import { useAuth } from "../../context/AuthContext";
import "../../style/AsignarMateriasProfesor.css";

function AsignarMateriaProfesor() {
  const { user, token } = useAuth();

  // Estados de datos
  const [profesores, setProfesores] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);

  // Estados de formulario
  const [profesorId, setProfesorId] = useState("");
  const [materiaId, setMateriaId] = useState("");
  const [gradoNombre, setGradoNombre] = useState("");
  const [grupo, setGrupo] = useState("");

  // Estados de UI
  const [mensaje, setMensaje] = useState("");
  const [mostrarAsignaciones, setMostrarAsignaciones] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Obtenemos el nombre del profesor seleccionado de forma eficiente
  const profesorNombre = useMemo(() => {
    const p = profesores.find((prof) => prof.id === Number(profesorId));
    return p ? `${p.nombre} ${p.apellido}` : "";
  }, [profesorId, profesores]);

  /* =========================================
      🔄 CARGA DE DATOS (USANDO AXIOS CENTRALIZADO)
  ========================================= */
  const fetchInitialData = useCallback(async () => {
    if (!token) return;
    try {
      // No necesitamos pasar headers manualmente si axiosAuth ya los incluye
      const [profRes, matRes, gradosRes] = await Promise.all([
        axios.get("/asignaciones/profesores"),
        axios.get("/asignaciones/materias"),
        axios.get("/asignaciones/grados")
      ]);
      setProfesores(profRes.data || []);
      setMaterias(matRes.data || []);
      setGrados(Array.isArray(gradosRes.data) ? gradosRes.data : []);
    } catch (error) {
      console.error("❌ Error en carga inicial:", error);
    }
  }, [token]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  // Cargar grupos cuando cambia el grado
  useEffect(() => {
    if (!gradoNombre) return;
    const fetchGrupos = async () => {
      try {
        const res = await axios.get(`/asignaciones/grupos-matriculas/${encodeURIComponent(gradoNombre)}`);
        setGrupos(res.data[gradoNombre] || []);
        setGrupo(""); 
      } catch (error) {
        setGrupos([]);
      }
    };
    fetchGrupos();
  }, [gradoNombre]);

  /* =========================================
      🛰️ WEBSOCKET (URL DESDE CONFIG)
  ========================================= */
  useEffect(() => {
    if (!user?.tenant_id) return;

    const socket = io(SOCKET_URL, { transports: ["websocket"] });

    socket.on("nueva-asignacion", (data) => {
      if (data.tenant_id === user.tenant_id) {
        setAsignaciones((prev) => [data, ...prev]);
      }
    });

    return () => socket.disconnect();
  }, [user?.tenant_id]);

  /* =========================================
      💾 ACCIONES CRUD
  ========================================= */
  const fetchAsignaciones = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/asignaciones");
      setAsignaciones(res.data || []);
    } catch (error) {
      setMensaje("❌ Error al cargar listado");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("/asignaciones", {
        profesor_id: Number(profesorId),
        materia_id: Number(materiaId),
        grado: gradoNombre,
        grupo,
      });

      setMensaje("✅ Asignación realizada");
      setMateriaId("");
      setGradoNombre("");
      setGrupo("");
      if (mostrarAsignaciones) fetchAsignaciones();
    } catch (error) {
      setMensaje(error.response?.data?.msg || "❌ Error al asignar");
    }
  };

  const eliminarAsignacion = async (id) => {
    if (!window.confirm("¿Eliminar carga académica?")) return;
    try {
      await axios.delete(`/asignaciones/${id}`);
      setMensaje("🗑️ Registro eliminado");
      fetchAsignaciones();
    } catch (error) {
      setMensaje("❌ Error al eliminar");
    }
  };

  return (
    <div className="asignar-container">
      <header className="asignar-header">
        <h2>📂 Carga Académica</h2>
        <p>Sede: <strong>{user?.sede_nombre}</strong></p>
      </header>

      <form className="asignar-form" onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="input-field">
            <label>Docente:</label>
            <select value={profesorId} onChange={(e) => setProfesorId(e.target.value)} required>
              <option value="">Seleccione profesor</option>
              {profesores.map((p) => (
                <option key={p.id} value={p.id}>{p.nombre} {p.apellido}</option>
              ))}
            </select>
          </div>

          <div className="input-field">
            <label>Materia:</label>
            <select value={materiaId} onChange={(e) => setMateriaId(e.target.value)} required>
              <option value="">Seleccione materia</option>
              {materias.map((m) => (
                <option key={m.id} value={m.id}>{m.nombre}</option>
              ))}
            </select>
          </div>

          <div className="input-field">
            <label>Grado:</label>
            <select value={gradoNombre} onChange={(e) => setGradoNombre(e.target.value)} required>
              <option value="">Grado...</option>
              {grados.map((g, i) => <option key={i} value={g}>{g}</option>)}
            </select>
          </div>

          <div className="input-field">
            <label>Grupo:</label>
            <select value={grupo} onChange={(e) => setGrupo(e.target.value)} required>
              <option value="">Grupo...</option>
              {grupos.map((gr) => <option key={gr} value={gr}>{gr}</option>)}
            </select>
          </div>
        </div>

        <button type="submit" className="btn-asignar">Guardar Asignación</button>
      </form>

      <div className="footer-actions">
        <button onClick={() => { setMostrarAsignaciones(!mostrarAsignaciones); if(!mostrarAsignaciones) fetchAsignaciones(); }}>
          {mostrarAsignaciones ? "Ocultar Datos" : "Ver Asignaciones"}
        </button>
        {mensaje && <span className="status-msg">{mensaje}</span>}
      </div>

      {mostrarAsignaciones && (
        <table className="tabla-asignaciones">
          <thead>
            <tr>
              <th>Docente</th>
              <th>Materia</th>
              <th>Grupo</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {asignaciones.map((a) => (
              <tr key={a.id}>
              <td>{a.profesor}</td>
<td>{a.materia}</td>

                <td>{a.grado}°{a.grupo}</td>
                <td><button onClick={() => eliminarAsignacion(a.id)}>❌</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AsignarMateriaProfesor;